import { module as m } from 'modujs';
import gsap from "gsap";
import {throttle} from "lodash";
import {html} from "../../utils/environment";

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.isOut = true;

        // FUNC
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
    }

    init() {
    }

    /**
     * ENTER
     */
    enter() {
        const _tl = gsap.timeline({
            delay: 0.2
        });
        _tl.to(this.el.querySelector('.line'), {
            duration: 1.2,
            scaleX: 1,
            ease: 'power4.inOut'
        });
        _tl.to([this.el.querySelector('.logo'), this.el.querySelectorAll('li > a')], {
            duration: 0.8,
            opacity: 1,
            y: 0,
            rotation: 0.1,
            stagger: 0.02,
            ease: 'power4.out'
        }, 0.4);
    }

    /**
     * HIDE
     */
    hide() {
        if(this.isOut) {
            this.isOut = false;
            gsap.to(this.el, {
                duration: 0.6,
                yPercent: -10,
                autoAlpha: 0,
                ease: 'power4.out'
            });
        }
    }

    /**
     * SHOW
     */
    show() {
        if(!this.isOut) {
            this.isOut = true;
            gsap.to(this.el, {
                duration: 0.6,
                yPercent: 0,
                autoAlpha: 1,
                ease: 'power4.out'
            });
        }
    }
}
